import { camelCase } from 'lodash-es';
import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import { NursingArea } from '@pflegia/types/api/candidate/nursing-area';
import { RegisterOrigin } from '@pflegia/types/api/candidate/register-origin';
import { FunnelQuestion, FunnelQuestionCategory } from '@pflegia/types/api/funnel/questions';
import { transformedEventProperties } from '@pflegia/ui/application/marketing/tracking/utils/transformed-event-properties';
import HeroButton from '@pflegia/ui/shared/hero-button/HeroButton';
import { getEnumValues } from '@pflegia/util/common/enum/helpers';

import { useFunnelState } from '@funnel/hooks/use-funnel-state';

import { FUNNEL } from '@shared/application/constants';
import { getEventProperty } from '@shared/application/marketing/funnel-event-marketing-to-event-property';
import { funnelQuestionToFunnelEventMarketing } from '@shared/application/marketing/funnel-question-to-funnel-event-marketing';
import { useTracking } from '@shared/application/tracking.service';

const SELECTABLE_NURSING_AREAS = getEnumValues(NursingArea, [NursingArea.Docia]);

const NursingAreaButtons: React.FC<{ registerOrigin?: RegisterOrigin }> = ({ registerOrigin }) => {
  const { t } = useTranslation('candidateFields', { keyPrefix: 'nursingArea' });
  const { trackEventRegistration } = useTracking();

  const setAnswers = useFunnelState(state => state.setAnswers);
  const handleNursingAreaClick = (nursingArea: NursingArea) => {
    const questionId = FunnelQuestion.NursingAreaWorking;
    const eventName = funnelQuestionToFunnelEventMarketing[questionId];
    trackEventRegistration(
      eventName,
      transformedEventProperties({ [getEventProperty(eventName)]: nursingArea }),
      questionId,
      FunnelQuestionCategory.Field,
    );

    setAnswers({ [FunnelQuestion.NursingAreaWorking]: nursingArea });
  };

  return (
    <div className='grid grid-cols-1 justify-center gap-2 lg:grid-cols-2'>
      {SELECTABLE_NURSING_AREAS.map(nursingArea => (
        <HeroButton
          dataTestId={`nursing-area-button-${nursingArea}`}
          href={{ pathname: FUNNEL, query: { id: FunnelQuestion.EmployeeType, ...(registerOrigin && { registerOrigin }) } }}
          key={nursingArea}
          onClick={() => handleNursingAreaClick(nursingArea)}>
          {t(camelCase(nursingArea))}
        </HeroButton>
      ))}
    </div>
  );
};

export default NursingAreaButtons;
